import { useApiOperation } from "src/api/hooks";
import { getBuildingDeviceToRegister } from "src/api/iot/iot-api";
import {
  addIotDisplayCustomTabAsync,
  assignIotDeviceToCustomTabAsync,
  deleteCustomTabDeviceAsync,
  deleteIotDisplayCustomTabAsync,
  getIotDisplayCustomTabListAsync,
  getIotDisplaySettingDetailAsync,
  saveIotDisplayUseTabAsync,
  updateIotDisplayCustomTabAsync,
} from "src/api/iot/iot-config-api";

/**
 * IoT 탭 관리 API 커스텀 훅
 *
 * IoT 디스플레이 설정 관련 API 함수들을 제공합니다.
 * 비즈니스 로직은 각 컴포넌트에서 처리하고, 여기서는 순수한 API 호출만 담당합니다.
 *
 * 장점:
 * - API 함수 재사용성 향상
 * - 테스트 용이성 증대
 * - 코드 중복 제거
 * - 기존 로직 안전성 보장
 */
export const useIotTab = () => {
  // ========================================
  // API 함수들 (Pure API calls)
  // ========================================

  /** IoT 디스플레이 설정 상세 조회 API */
  const { executeAsync: getPartnerIotSettingInfo } = useApiOperation(getIotDisplaySettingDetailAsync);

  /** IoT 탭 활성화 설정 저장 API */
  const { executeAsync: saveIotDisplayUseTab } = useApiOperation(saveIotDisplayUseTabAsync);

  /** 커스텀/기본 탭 목록 조회 API */
  const { executeAsync: getIotDisplayCustomTabList } = useApiOperation(getIotDisplayCustomTabListAsync);

  /** 커스텀 탭에 IoT 기기 연결 API */
  const { executeAsync: assignIotDeviceToCustomTab } = useApiOperation(assignIotDeviceToCustomTabAsync);

  /** 커스텀 탭에서 IoT 기기 연결 해제 API */
  const { executeAsync: deleteCustomTabDevice } = useApiOperation(deleteCustomTabDeviceAsync);

  /** 새 커스텀 탭 생성 API */
  const { executeAsync: addIotDisplayCustomTab } = useApiOperation(addIotDisplayCustomTabAsync);

  /** 기존 커스텀 탭 수정 API */
  const { executeAsync: updateIotDisplayCustomTab } = useApiOperation(updateIotDisplayCustomTabAsync);

  /** 기존 커스텀 탭 삭제 API */
  const { executeAsync: deleteIotDisplayCustomTab } = useApiOperation(deleteIotDisplayCustomTabAsync);
  const { executeAsync: getIotDeviceToRegister } = useApiOperation(getBuildingDeviceToRegister);

  return {
    // API 함수들 (비즈니스 로직은 각 컴포넌트에서 처리)
    getPartnerIotSettingInfo,
    saveIotDisplayUseTab,
    getIotDisplayCustomTabList,
    assignIotDeviceToCustomTab,
    deleteCustomTabDevice,
    addIotDisplayCustomTab,
    updateIotDisplayCustomTab,
    deleteIotDisplayCustomTab,
    getIotDeviceToRegister,
  };
};
